<div
  class="row"
  style="display: flex; align-items: center; justify-content: space-between"
>
  <span class="col">
    {{ data.message }}
  </span>
  <button
    mat-icon-button
    (click)="snackBarRef.dismiss()"
    style="height: 40px; padding: 0"
  >
    <mat-icon style="color: #ffffff">close</mat-icon>
  </button>
</div>
